import {
  CorrectionReasonOptions,
  DeliveryContextGMNOptions,
  GmnEventType,
  GroundwaterAspectOptions,
  MonitoringPurposeOptions,
  QualityRegimeOptions,
  RegistrationMeasuringPoint,
  correctionReasonOptions,
  deliveryContextGMNOptions,
  gmnEventOptions,
  groundwaterAspectOptions,
  monitoringPurposeOptions,
  qualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

const GMN_FIELD_SCHEMA_LIBRARY = {
  // Shared metadata fields
  projectNumber: addSchema<string>({ type: "string", title: "Projectnummer" }),
  broId: addSchema<string>({ type: "string", title: "BRO-ID Meetnet" }),
  qualityRegime: addSchema<QualityRegimeOptions>({
    type: "string",
    title: "Kwaliteitsregime",
    enum: qualityRegimeOptions.map((opt) => opt.value),
  }),
  deliveryAccountableParty: addSchema<string>({
    type: "string",
    title: "Bronhouder [KVK]",
  }),
  correctionReason: addSchema<CorrectionReasonOptions>({
    type: "string",
    title: "Correctie reden",
    enum: correctionReasonOptions.map((opt) => opt.value),
  }),

  // GMN Start Registration fields
  name: addSchema<string>({ type: "string", title: "Naam" }),
  objectIdAccountableParty: addSchema<string>({ type: "string", title: "Interne naam" }),
  deliveryContext: addSchema<DeliveryContextGMNOptions>({
    type: "string",
    title: "Kader aanlevering",
    enum: deliveryContextGMNOptions.map((opt) => opt.value),
  }),
  monitoringPurpose: addSchema<MonitoringPurposeOptions>({
    type: "string",
    title: "Monitoring doel",
    enum: monitoringPurposeOptions.map((opt) => opt.value),
  }),
  groundwaterAspect: addSchema<GroundwaterAspectOptions>({
    type: "string",
    title: "Grondwater aspect",
    enum: groundwaterAspectOptions.map((opt) => opt.value),
  }),
  startDateMonitoring: addSchema<string>({
    type: "string",
    format: "date",
    title: "Startdatum monitoring",
  }),
  measuringPoints: addSchema<RegistrationMeasuringPoint[]>({
    type: "array",
    title: "Monitoringbuizen",
    items: {
      type: "object",
      properties: {
        measuringPointCode: { type: "string" },
        broId: { type: "string" },
        tubeNumber: { type: "string" },
      },
      required: ["measuringPointCode", "broId", "tubeNumber"],
    },
  }),

  // GMN Closure fields
  endDateMonitoring: addSchema<string>({
    type: "string",
    format: "date",
    title: "Einddatum monitoring",
  }),

  // GMN Edit Measuring Point fields
  eventType: addSchema<GmnEventType>({
    type: "string",
    title: "Event type",
    enum: gmnEventOptions.map((opt) => opt.value),
  }),
  eventDate: addSchema<string>({ type: "string", format: "date", title: "Event datum" }),
  measuringPointCode: addSchema<string>({ type: "string", title: "Meetpuntcode" }),
  tubeNumber: addSchema<string>({ type: "string", title: "Buisnummer" }),

  // File fields
  measuringPointsFile: addSchema<Blob>({
    type: "string",
    format: "data-url",
    title: "Meetpunten bestand (Excel)",
  }),
};

type GmnFieldSchemaLibraryType = typeof GMN_FIELD_SCHEMA_LIBRARY;

export function pickGmnLibraryFields<K extends keyof GmnFieldSchemaLibraryType>(
  fieldNames: readonly K[]
): Pick<GmnFieldSchemaLibraryType, K> {
  return Object.fromEntries(
    fieldNames.map((name) => [name, GMN_FIELD_SCHEMA_LIBRARY[name]])
  ) as Pick<GmnFieldSchemaLibraryType, K>;
}
